(function() {
  'use strict';
  angular.module('benefits')
  .filter('frequencyRules', function() {
    return function(limitations) {
        if (limitations) {
          return limitations.rules ? _.orderBy(limitations.rules,['frequency'],['desc']) : [limitations];
        }
    };
  })
  .filter('primaryFrequencyRule', function(frequencyRulesFilter) {
    return function(limitations) {
          let rules = frequencyRulesFilter(limitations);
          if (rules && rules.length > 0) {
            return rules[0].frequency &&  rules[0].frequency === false ? '' : rules[0];
          }else{
            return '';
          }
    };
  })
  .filter('frequency', function() {
    var units = {
      'benefitPeriod': 'benefit period'
    };
    return function(limitations, rulesIndex) {
      rulesIndex = rulesIndex ? rulesIndex : 0;
      if(!limitations.occurrences) {
        return "";
      } else {
        let occurrences = limitations.occurrences + " times";
        let frequencyText = ' per ';
        /*
        All this unit garbage is so we show something like "Only once per tooth" instead of
        "Once per lifetime per tooth."
        */
        let unit = units[limitations.unit] !== undefined ? units[limitations.unit] : limitations.unit;
        if (limitations.occurrences === 1) {
          occurrences = "Once" ;
        } else if (limitations.occurrences === 2) {
          occurrences = "Twice";
        }

        if (limitations.frequency === false) {
            occurrences = "Cannot be done";
            frequencyText = ' within ';
        }

        if (rulesIndex > 0) { /* Multiple frequency rules */
          occurrences =  'And ' + occurrences.charAt(0).toLowerCase() + occurrences.substr(1);
        }

        return occurrences + ' ' +
          (limitations.type == "tooth" || limitations.type == "quadrant" ? " per "+ limitations.type : "") + frequencyText +
          (limitations.length == 1 ? "" : (limitations.length + " ")) +
          unit;
      }
    };
  });
})();
